import { render, staticRenderFns } from "./ListEvents.vue?vue&type=template&id=1f8abda7&scoped=true"
import script from "./ListEvents.vue?vue&type=script&lang=js"
export * from "./ListEvents.vue?vue&type=script&lang=js"
import style0 from "./ListEvents.vue?vue&type=style&index=0&id=1f8abda7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8abda7",
  null
  
)

export default component.exports